import t from 'utils/translateFunc';
import { trackingCode } from 'data/trackingCode';

export const textToTime = text => {
  const options = { hour: 'numeric', minute: 'numeric' };
  const date = new Date(text);
  const newViewTime = new Intl.DateTimeFormat('en-US', options).format(date);
  return newViewTime;
};

export const textToDate = text => {
  if (text) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const date = new Date(text);
    const newViewDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return newViewDate;
  }
  return '';
};

export const textToDateOrTime = (text, mode) => {
  if (text) {
    const arrInfoDate = text.split(' ');
    if (mode === 'time') {
      return arrInfoDate[1];
    } else if (mode === 'date') {
      return arrInfoDate[0];
    }
    return text;
  }
  return '';
};

export const roundFn = (sum, language) => {
  const q = Number(sum);
  let roundSum = {};
  q < 1.0e3
    ? (roundSum = { number: q, text: '' })
    : q < 1.0e6
    ? (roundSum = {
        number: Math.round(q / 1.0e2) / 10,
        text: t('roundFn', 'K', language)
      })
    : (roundSum = {
        number: Math.round(q / 1.0e5) / 10,
        text: t('roundFn', 'M', language)
      });
  return roundSum;
};

export const parsEventCode = eventCode => {
  const event = trackingCode[eventCode];
  return event ? event : 'no name event';
};

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
};

export const declOfNum = (number, titles) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};
